// Angular
import { Component, Input } from '@angular/core';

// Afidium
import { IGetBookingsStayResponse } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { ISummarySectorStay } from '../shared/interfaces/ISummary';
import { ITableSectorServices } from '../shared/services/table-services/table-services.service';

@Component({
    selector: 'sectors-stay',
    template: `
        <div class="sectors" [class.details-closed]="!detailsIsShown">
            <stay-summary [sector]="sector" [detailsIsShown]="detailsIsShown" [booking]="booking"></stay-summary>

            <div class="informations">
                <div [hidden]="view !== 'details'" class="informations-container">
                    <sector-stay-details [sector]="sector"
                                         [booking]="booking">
                    </sector-stay-details>
                </div>

                <div [hidden]="view !== 'services'" class="informations-container">
                    <sector-stay-services
                            [booking]="booking"
                            [sector]="sector"
                            [tableServices]="tableServices">
                    </sector-stay-services>
                </div>
            </div>
        </div>
    `,
    styles: [`
        .sectors {
            display: flex;
        }

        stay-summary {
            display: block;
            width: 225px;
            padding: .75rem;
            background-color: #fefefe;
        }

        .informations-container {
            flex: 1;
        }

        .informations {
            flex: 1;
        }

        .details-closed stay-summary {
            width: 100%;
        }

        .details-closed .informations {
            display: none;
        }
    `]
})
export class SectorsStayComponent {
    @Input()
    public booking: IGetBookingsStayResponse;

    @Input()
    public sector: ISummarySectorStay;

    @Input()
    public view: string;

    @Input()
    public detailsIsShown: boolean = true;

    @Input()
    public tableServices: ITableSectorServices;
}
